const info = {
  ZH: { //中文翻译
    searchstandard: '查找标准',
    startsource: '请求类型',
    self: '自己的',
    already: '已接收',
    batch:"批次",
    overDueOrNot:"是否逾期",
    mdsdatatype: '材料数据表类型',
    mdsall: '全部',
    mdspart: '零部件',
    mdshalfpart: '半成品件',
    mdsmaterial: '材料',
    cproject: '项目名称',
    crecpeople: '材料数据表 供应商',
    csendpeople: '材料数据接收方(请求方)',
    mdscdeadline: '截止日期',
    ctypenum: '供货编号',
    rdName: '供货名称',
    alreadyMDS: '已指派的材料数据表(ID)',
    requeststatus: '请求状态',
    new: '新的',
    sent: '已发送',
    working: '工作中',
    waitacceptance: '等待批准',
    completed: '已批准',
    rejected: '已拒绝',
    deleted: '已删除',
    received: '已接收',
    alreadyrejected: '已拒绝',
    search: '查找',
    bad: '没有符合条件的数据!',
    create: '创建',
    requestTitle: '请求',
    subTitle: '材料数据表的请求',
    orderby: '按照',
    rollback: '返回',
    watch: '查看',
    edit: '编辑',
    del: '删除',
    send: '发送',
    reject: '拒绝',
    setmdsid: '指派的材料数据表 (ID)',
    setmdscid: '指派的材料数据表 (CID/版本号)',
    orderbyAsc: '升序',
    orderbyDesc: '降序',
    orderbyAoD: '排序',
    suredel: '确定要删除此请求?',
    mdsdatahaddel: '此材料数据表请求已被删除!',
    rejectreason: '拒绝理由',
    submit: '确定',
    cancel: '取消',
    giverejectreason: '请给出您拒绝的理由!',
    select: '请选择一条记录！',
    oldmdsidtitle: '原始材料数据表',
    newMDS: '供应商材料数据表',
    refuse: '拒绝原因',
    setmds: '指派',
    updatemds: '修改',
    showmds: '查看',
    previewmds: '预览',
    analyzemds: '分析',
    requestData:"请求数据",
    removemds: '解除指派',
    hadsetmds: '已指派材料数据表!',
    removemdsTorF: '确认解除指派的材料数据表?',
    hadSameSendOrg: '该表单的接收方已包含本请求的发送企业，请查找该表单进行确认或重新指派。',
    noFileUpload:'无文件上传',
    progressStatistics:"进度统计",
   enterprojectnameornumber:'请输入项目名或批次号',
   
  },
  EN: { //英文翻译
    searchstandard: 'search criteria',
    startsource: 'Request type',
    self: 'Own',
    already: 'Received',
    batch:"Batch",
    mdsdatatype: 'MDS type',
    mdsall: 'All',
    mdspart: 'Component',
    mdshalfpart: 'SemiComponent',
    mdsmaterial: 'Material',
    cproject: 'Project Name',
    crecpeople: 'MDS Supplier',
    csendpeople: 'MDS Recipient (Requester)',
    mdscdeadline: 'Deadline',
    ctypenum: 'Designated No. by customer',
    rdName: 'Designated Name by customer',
    alreadyMDS: 'Assigned MDS(ID)',
    requeststatus: 'Request Status',
    new: 'New',
    sent: 'Sent',
    working: 'Working',
    waitacceptance: 'Wait for acceptance',
    completed: 'Accepted',
    rejected: 'Rejected',
    deleted: 'Deleted',
    received: 'Received',
    alreadyrejected: 'Rejected',
    search: 'Search',
    bad: 'no suitable data!',
    create: 'Create',
    requestTitle: 'MDS Request',
    subTitle: 'MDS Request',
    orderby: 'By',
    rollback: 'Back',
    watch: 'View',
    edit: 'Edit',
    del: 'Delete',
    send: 'Send',
    reject: 'Reject',
    setmdsid: 'Assigned MDS(ID)',
    setmdscid: 'Assigned MDS(CID/VER)',
    orderbyAsc: 'Ascending',
    orderbyDesc: 'Descending',
    orderbyAoD: 'Order',
    suredel: 'Are you sure to delete this request?',
    mdsdatahaddel: 'The MDS has been removed!',
    rejectreason: 'Reason for rejection',
    submit: 'OK',
    cancel: 'Cancel',
    giverejectreason: 'Please give your reasons for rejection!',
    select: 'Please select an item!',
    oldmdsidtitle: 'original MDS',
    newMDS: 'Supplier\'s MDS',
    refuse: 'Refuse to cause',
    setmds: 'Assign MDS',
    updatemds: 'Modify',
    showmds: 'View',
    previewmds: 'Preview',
    analyzemds: 'Analysis',
    requestData:"Request data",
    removemds: 'Remove the assigned',
    hadsetmds: 'Assign MDS',
    removemdsTorF: 'Are you sure unassign MDS?',
    hadSameSendOrg: 'The recipient of the MDS contain the sending enterprise of the request,please check the MDS or reassign.',
    noFileUpload:'No file upload',
    progressStatistics:"Progress Statistics",
     enterprojectnameornumber:'Please enter project name or batch',
  }
}
export default info //需要暴露出去
